import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { AppidService } from 'src/app/base/services/appid/appid.service';
import { take } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RouteService {

  appID: number;

  constructor(private http: HttpClient, private appidService: AppidService) {}

    /**
     * Fetches the routes from the V2.
     *
     * This function makes an HTTP GET request to the specified endpoint to retrieve the
     * routes available for the currently authenticated user based on their role. The
     * retrieved data is returned as a Promise.
     * @returns {Promise<any>} A Promise containing the routes.
     *
     */
    async getRoutes(): Promise<any> {
        if (!this.appID) {
          this.appID = await this.appidService.getAppID();
        }

        try {
            let httpParams = new HttpParams()
                .set('app_id', this.appID);
            const routeName = await this.http.get<any>(environment.urls.core + "/auth/routes", {
              params: httpParams
            }).toPromise();
            return routeName;
        } catch (error) {
            console.error('Error fetching routes:', error);
            throw error;
        }
    }
}